// users.options flag that records whether the new-user ResumAI walkthrough has been shown.
// Reuses the same flag the previous (now-retired) intro.js "Welcome to ResumAI!" builder tour
// used (see markBuilderPassed in api/profile.js) rather than inventing a new one — existing
// users who already passed that tour are correctly left alone by this rebuilt one. EN-806
// re-introduces the score system to those existing users separately, with its own shorter
// step set gated by its own flag (see RESUME_SCORE_WHATS_NEW_TUTORIAL_FLAG in
// utils/resume-score-whats-new-tutorial.js), which only fires once this flag is already set.
export const RESUME_SCORE_TUTORIAL_FLAG = 'builder_passed';

// Pure gate (kept side-effect free so it's easy to unit test in isolation).
export const canShowResumeScoreTutorial = (user) =>
	Boolean(user) && ! user.options?.[RESUME_SCORE_TUTORIAL_FLAG];

// The Target Role tutorial step needs to know whether this resume already has a role to score
// against. There's no per-resume target-title field yet (EN-796 still pending), so `job_title`
// on the user is the same signal the score panel itself already reads for this today —
// sidebar-scorer.vue's `isJobTitleSet` and resume-score.vue's `user?.job_title == null` gate
// both key off it to decide whether to show the "no role set" empty state. Reused as-is by
// EN-806's "what's new" tour for existing users, whose Target Role step only changes its copy
// (not the underlying detection signal) between the role-set and no-role cases.
export const hasTargetRole = (user) => user?.job_title != null;
